<table class="client-table" [cellSpacing]="0">
  <thead>
    <tr>
      <th>{{'NAME' | translate}}</th>
      <th>{{ 'NUMBER_OF_COACHES' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let tenant of tenants" [routerLink]="['../tenants', tenant.id]">
      <td>{{ tenant.name }}</td>
      <td>{{ tenant.coaches.edges.length }}</td>
    </tr>
  </tbody>
</table>
